<template>
    <section class="cnc-services-section">
        <div class="container">
            <h2 class="section-title">Our Manufacturing Services</h2>
            <p class="desc">
                XCL offers top-notch manufacturing capabilities, perfect for rapid prototypes and custom production orders. Our self-owned factory and extensive Chinese manufacturing network are equipped to deliver complex, and quality parts efficiently.
            </p>
            
            <div class="services-grid">
                <router-link 
                    class="service-card" 
                    v-for="(item, index) in serviceList" 
                    :key="index"
                    :to="item.link"
                >
                    <div class="top-right-icon">
                        <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="7" y1="17" x2="17" y2="7"></line>
                            <polyline points="7 7 17 7 17 17"></polyline>
                        </svg>
                    </div>

                    <div class="card-image">
                        <img :src="item.image" :alt="item.title" />
                    </div>
                    
                    <div class="card-content">
                        <h3 class="card-title">{{ item.title }}</h3>
                        <p class="card-desc">{{ item.desc }}</p>
                    </div>
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'New_Services',
    setup() {
        // 数据列表：保留了原来的 require 路径格式，并增加了 link 路由字段
        const serviceList = [
            {
                image: require('@/assets/images/home/1.jpg'),
                title: 'CNC Machining',
                desc: 'Achieve precise, intricate designs with milling, turning, and post-processing, ideal for both complex prototypes and functional metal parts.',
                link: '/cnc-machining' 
            },
            {
                image: require('@/assets/images/home/3.jpg'),
                title: 'Sheet Metal',
                desc: 'Fabricate durable, versatile components with precise cutting, forming, assembly, and custom finishing, ideal for both rapid prototypes and robust structural parts.',
                link: '/sheet-metal'
            },
            {
                image: require('@/assets/images/home/2.jpg'),
                title: '3D Printing',
                desc: 'Fast and versatile, this method quickly creates complex geometries from diverse materials, perfect for innovative designs.',
                link: '/3d-printing'
            },
            {
                image: require('@/assets/images/home/5.jpg'),
                title: 'Die Casting',
                desc: 'Ideal for the high-precision manufacturing of metal parts, this process excels in large volumes, ensuring consistent quality across all pieces.',
                link: '/die-casting'
            },
            {
                image: require('@/assets/images/home/4.jpg'),
                title: 'Compression Molding',
                desc: 'Produce highly customized molded components with precise heat and pressure, enhanced by exact color matching, tailored finishes, and pad printing, ideal for durable thermoset and elastomer parts.',
                link: '/compression-molding'
            }
        ]

        return { serviceList }
    },
}
</script>

<style scoped>
/* --- 全局与背景 --- */
.cnc-services-section {
    width: 100% !important;
    background-color: #f2f5f7 !important; /* 柔和的高级灰背景 */
    padding: 80px 20px;
    position: relative !important;
    z-index: 1;
}

/* --- 容器 --- */
.container {
    max-width: 1140px; 
    margin: 0 auto !important;
    width: 100%;
    display: block;
}

/* --- 标题与描述 --- */
.section-title {
    font-size: 32px !important; 
    font-weight: 700 !important;
    color: #1a1a1a !important;
    text-align: center;
    margin-bottom: 24px;
    position: relative;
}

.desc {
    text-align: center;
    margin-bottom: 50px;
    color: #555;
    line-height: 1.6;
    max-width: 800px; /* 限制描述文字最大宽度，提升阅读体验 */
    margin-left: auto;
    margin-right: auto;
}

/* --- 弹性布局网格 (最后一行自动居中) --- */
.services-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center; 
    gap: 32px; /* 加大间距，增加呼吸感 */
    margin-bottom: 40px;
    width: 100%;
    box-sizing: border-box;
}

/* --- 卡片基础样式 --- */
.service-card {
    width: calc((100% - 64px) / 3); /* 对应 32px 的间距 (32*2=64) */
    max-width: 320px; /* 强制最大宽度，限制拉伸，让卡片变得修长精致 */
    background: #fff;
    border-radius: 8px; /* 加入圆角，提升现代感 */
    overflow: hidden;
    border: 1px solid #eaeaea; 
    display: flex;
    flex-direction: column;
    height: auto; 
    box-sizing: border-box;
    cursor: pointer;
    
    /* router-link 样式重置 */
    text-decoration: none;
    color: inherit;
    position: relative; /* 供右上角图标绝对定位使用 */
    
    /* 悬浮动画过渡设置 */
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); 
}

/* 卡片悬浮效果 */
.service-card:hover {
    border-color: transparent; 
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08); /* 均匀柔和的高级阴影 */
    transform: translateY(-5px); /* 轻微上浮 */
}

/* --- 右上角图标样式 --- */
.top-right-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #16bc9c; /* 主题色 */
    z-index: 2;
    transition: transform 0.3s ease, opacity 0.3s ease;
    opacity: 0.8; /* 常态略微透明 */
}

/* 卡片悬浮时，触发图标动效 */
.service-card:hover .top-right-icon {
    opacity: 1; 
    transform: translate(3px, -3px) scale(1.1); /* 向右上角微动并放大 */
}

/* --- 统一大小且居中的图片容器 --- */
.card-image {
    width: 100%;
    height: 220px; /* 压低图片区域高度，消除头重脚轻感 */
    overflow: hidden;
    flex-shrink: 0;
    
    /* Flex 居中 */
    display: flex;          
    justify-content: center; 
    align-items: center;     
    background-color: #fff; 
    
    padding: 24px; /* 内边距防贴边 */
    box-sizing: border-box;
}

.card-image img {
    width: 100%;       
    height: 100%;      
    max-height: 160px; /* 强制统一最大高度 */
    object-fit: contain; /* 保证整图完整展示 */
    display: block; 
    transition: transform 0.3s ease; 
}

/* 卡片悬浮时，图片轻微放大 */
.service-card:hover .card-image img {
    transform: scale(1.05);
}

/* --- 文本内容区域 --- */
.card-content {
    padding: 0 24px 30px 24px; 
    display: flex;
    flex-direction: column;
    flex: 1;
}

.card-title {
    font-size: 18px;
    font-weight: 600;
    color: #111827;
    line-height: 1.4;
    flex-shrink: 0;
    margin-bottom: 12px;
    transition: color 0.3s ease; 
}

/* 卡片悬浮时，标题文字变色 */
.service-card:hover .card-title {
    color: #16bc9c; 
}

.card-desc {
    font-size: 14px;
    color: #6b7280;
    line-height: 1.6;
    margin-bottom: 0px;
}

/* --- 响应式适配 --- */
@media (max-width: 992px) {
    .service-card {
        width: calc((100% - 32px) / 2); /* 平板端显示两列 */
        max-width: 340px; /* 平板稍微放宽限制 */
    }
}

@media (max-width: 640px) {
    .service-card {
        width: 100%; /* 手机端单列显示 */
        max-width: 100%; /* 手机端解除最大限制，占满整行 */
    }
}
</style>